import React, { useState } from "react";

import {  useSearchParams } from "react-router-dom";
import useAxiosFetch from "../common/useAxiosFetch";

import CoPilotForm from "./CoPilotForm";
import LoadPage from "../common/LoadPage";

const EditCoPilotPage = () => {
    const [searchParams] = useSearchParams();
    const copilotId = searchParams.get("copilotId");

    const { data, loading } = useAxiosFetch("/api/copilot/" + copilotId);

    if (loading)
        return <LoadPage />;

    return (
        <div id="content">
            <div id="content-title">Update CoPilot Question</div>

            <div className="content-bubble">

                <CoPilotForm 
                    copilotData={data}
                    copilotId={copilotId}
                />
            </div>
        </div>
    );
  
};

export default EditCoPilotPage;
